<script>
export default {
  name: 'AutocompleteMany',

  props: {
    label: { type: String, default: null },
    placeholder: { type: [Boolean, String], default: false },
    items: { type: Array, default: () => [] },
    id: { type: String, default: 'id' },
    text: { type: String, default: 'text' },
    selected: { type: [Array, String, Number], default: () => [] },
    multiple: { type: Boolean, default: false },
    selectedItemsToShow: { type: Number, default: 1 },
    loadingProps: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    disabledProps: { type: Boolean, default: false },
    showDetails: { type: [Boolean], default: false },
  },
  data() {
    return {
      allItems: [],
      loading: false,
    }
  },
  computed: {
    normalizedPlaceholder() {
      if (this.placeholder === true) return 'Todos'
      if (
        typeof this.placeholder === 'string' &&
        this.placeholder.trim().length
      )
        return this.placeholder
      return ''
    },
    isAllSelected() {
      return this.items.length === this.selected.length
    },
    selectedFormatted() {
      if (this.multiple) {
        return this.selected
      } else {
        return this.selected[0] || this.selected
      }
    },
  },
  watch: {
    items: {
      handler(newItems) {
        this.allItems = newItems
      },
      immediate: true,
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      this.allItems = this.items
      this.loading = false
    },
    updateData(v) {
      this.$emit('update:selected', typeof v === 'string' ? [v] : v || [])
    },
    selectAll() {
      let data = []
      if (this.isAllSelected) {
        data = []
      } else {
        data = [...this.items].map((p) => p[this.id])
      }
      this.updateData(data)
    },
    remover(item) {
      const index = this.selected.indexOf(item)
      if (index !== -1) {
        const data = [...this.selected]
        data.splice(index, 1)
        this.updateData(data)
      }
    },
  },
}
</script>

<template>
  <div class="autocomplete-many">
    <v-autocomplete
      :value="selectedFormatted"
      :items="allItems"
      :item-value="id"
      :item-text="text"
      :label="label"
      :placeholder="normalizedPlaceholder"
      outlined
      :multiple="multiple"
      :hide-details="!showDetails"
      clearable
      class="new-ux small-close flex-grow-1"
      style="margin-top: 6px"
      :disabled="disabledProps || loadingProps"
      :loading="loading || loadingProps"
      :rules="rules"
      @change="updateData"
    >
      <template v-if="multiple" v-slot:selection="data">
        <v-chip
          v-if="data.index < selectedItemsToShow"
          v-bind="data.attrs"
          :input-value="data.selected"
          :close="multiple"
          small
          @click="data.select"
          @click:close="remover(data.item[id] || data.item)"
        >
          <span
            :style="{ width: selected.length > 1 ? '50px' : '75px' }"
            class="truncate text-xs"
          >
            {{ data.item[text] || data.item }}
          </span>
        </v-chip>
        <v-chip
          v-if="data.index === selectedItemsToShow"
          class="autocomplete-many-more"
          x-small
        >
          <span class="text-xxs font-bold">
            + {{ selected.length - selectedItemsToShow }}
          </span>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<style lang="sass">
.autocomplete-many
  .small-close
    .v-chip
      padding: 1px 6px
      i
        font-size: 14px
        margin-left: 0
  .v-select__selections
    flex-wrap: nowrap
  .autocomplete-many-more
    .v-chip__content
      white-space: nowrap
</style>
